// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"ff200ba9","415":"9e92f896","775":"f6bfa94b","914":"f51c6cb9"}[chunkId] + ".chunk.css";
};